import React, { useEffect } from "react";
import dynamic from 'next/dynamic';
import BookCard from "../../components/book_card";
const Breadcrumbs = dynamic(() => import("../../components/breadcrumbs"));
import sanityClient from "../../../public/support-func/sanityClient";
import Head from "next/head";
const Flowers = dynamic(() => import("../../components/flowers"));
import Banner from "../../components/banner";

export async function getStaticProps() {
	const pageMeta = await sanityClient.fetch(
		`*[_type == "metadata" && title == "/books"] `
	);
	const pageData = await sanityClient.fetch(
		`*[_type == "books" && active == true]`
	);

	return {
		props: {
			pageMeta: pageMeta[0],
			pageData,
		},
		revalidate: 300,
	};
}

const Books = ({ pageData, pageMeta }) => {
	useEffect(() => {
		window.scrollTo(0, 0);
		  // setPageNumber(Math.ceil(pageData?.length / postPerPage))
		document.querySelector('.flower_container_two')?.classList.add('none');
		document.querySelector('.flower_container_three')?.classList.add('none');
	  }, [])

	return (
		<>
			<Head>
				<title>{pageMeta.meta_title}</title>
				<meta name="description" content={pageMeta.meta_description} />
				<meta name="keywords" content={pageMeta.meta_keywords} />
			</Head>

			<Breadcrumbs pathArr={[{ name: "Книги", url: "/books" }]} />
			<Flowers />
			<h1 className="accent_text">Книги автора</h1>

			<Banner
				bannerImagesClass="goldria"
				title="Хроники Голдрии"
				title2="Темные лабиринты перемен"
				description="(название возможно будет изменено). На двух островах, что некогда были едины, творится безумие. Злая ведьма захватила трон Теврии с армией теней, а Муварией управляет обезумевший король. Принцесса Ализия отправилась на поиски Амулета, чтобы противостоять ведьме и вернуть себе Теврию. Принц Эдлард ищет в себе силы пойти против собственного отца и навести порядок в Муварии. Книга в процессе написания."
			/>

			{/* {pageData?.map((item: any, i: number) => {
				return (
					<BookCard
						key={i + "bl"}
						title={item.title}
						text={item.description}
						// imgUrl={item.url}
						link={item.url}
					/>
				);
			})} */}
		</>
	);
};

export default Books;
